import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch, withDefaults } from 'vue';
interface IProps {
    modelValue?: any;
    step: number;
    min: number;
    max: number;
    clear?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSliderRange',
  props: {
    modelValue: {},
    step: {},
    min: {},
    max: {},
    clear: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const range = ref<number[]>([]);
const props = __props;

const emit = __emit;
watch(
    () => range.value,
    () => {
        if (!!range.value && range.value.length > 0 && range.value.join('') != '00') {
            emit('update:modelValue', { start: range.value[0], end: range.value[1] });
        }

    }
);
watch(
    () => props.modelValue,
    () => {

        if (props.modelValue && props.modelValue.start && props.modelValue.end) {

            range.value = [props.modelValue.start, props.modelValue.end];
        }

        // emit('update:modelValue', range.value);
    }
);

watch(
    () => props.clear,
    () => {

        if (props.clear) {
            range.value = [0, 0];
        }

    }
);

onMounted(() => {
    range.value = [0, 0]
})


return (_ctx: any,_cache: any) => {
  const _component_v_range_slider = _resolveComponent("v-range-slider")!

  return (_openBlock(), _createBlock(_component_v_range_slider, {
    modelValue: range.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
    max: props.max,
    min: props.min,
    step: props.step,
    "hide-details": "",
    class: "align-center",
    "thumb-label": "always"
  }, null, 8, ["modelValue", "max", "min", "step"]))
}
}

})